import { appPath } from "../utilities/app-base-path";

export const ASSETS_ROOT = "/assets";

export const ASSET_PATHS = {
	icons: {
		root: `${ASSETS_ROOT}/icons`,
		sprite: `${ASSETS_ROOT}/icons/general-icons.svg`,
	},
	images: {
		root: `${ASSETS_ROOT}/images`,
		logos: {
			mark: `${ASSETS_ROOT}/images/logo.svg`,
			full: `${ASSETS_ROOT}/images/full logo.svg`,
		},
		homeExternal: `${ASSETS_ROOT}/images/home-external`,
		illustrations: `${ASSETS_ROOT}/images/illustrations`,
	},
} as const;

export function assetPath(relativePath: string): string {
	const normalized = relativePath.replace(/^\//, "");
	const path = normalized.startsWith("assets/") ? `/${normalized}` : `${ASSETS_ROOT}/${normalized}`;
	return appPath(path);
}
